export const PASSWORD_CHECK_TEXT = {
    length: "Password must be at least 8 characters long",
    specialChar: "Password must contain at least one special character",
    upperCase: "Password must contain at least one uppercase letter",
    lowerCase: "Password must contain at least one lowercase letter",
    number: "Password must contain at least one number",
    match: "Passwords do not match",
};

export const PASSWORD_CHECK_ORDER = ["length", "specialChar", "upperCase", "lowerCase", "number", "match"];

export const getPasswordChecks = (password = "", confirmPassword = "") => ({
    length: password.length >= 8,
    specialChar: /[!@#$%^&*]/.test(password),
    upperCase: /[A-Z]/.test(password),
    lowerCase: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
    match: password.length > 0 && password === confirmPassword,
});

export const isPasswordValid = (passwordCheck = {}) => Object.values(passwordCheck).every(Boolean);
